import { IsDate, IsOptional } from 'class-validator';
import { BaseDto } from './base.dto';
import { CartDto } from './cart.dto';
import { EmployeeDto } from './employee.dto';
import { MerchantSaleUnitDto } from './merchantSaleUnit.dto';
import { OrderDto } from './order.dto';
import { SaleUnitCartDto } from './saleUnitCart.dto';
export class OrderPosTableInfoDto extends BaseDto {
  status: number;
  noPersons?: number;
  order: OrderDto;
  merchantSaleUnit: MerchantSaleUnitDto;
  saleUnitCart: SaleUnitCartDto;
  cart: CartDto;
  cartId?: number;
  guestId?: number | null;
  operatorEmployeeId?: number | null;
  operatorEmployee?: EmployeeDto | null;
  @IsOptional()
  @IsDate()
  openDate?: Date;
}
